import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from '../shared/ClaimListing/ClaimListing';

export default function SendTab() {
  return (
    <ClaimListing
      columns={[
        ClaimColumns.insuredName,
        ClaimColumns.reinsuranceYear,
        ClaimColumns.policyNumber,
        ClaimColumns.sce,
        ClaimColumns.whatSent,
      ]}
      filters={[ClaimFilters.insuredNameSearch]}
      additionalPayload={{ status: ClaimStatus.Send }}
      columnsSortable={false}
      includeExport={false}
    />
  );
}
